import React, { Children } from 'react'

import { Text } from '@doist/marketist'

import cn from 'classnames'
import { Interpolate } from 'components'
import { useTranslation } from 'next-i18next'

import css from './Plan.module.css'

export function Plan({
    title,
    children,
    currencySymbol = '$',
    cost,
}: {
    title: string
    children: React.ReactNode
    currencySymbol: string
    cost: string
}) {
    const { t } = useTranslation('pricing')

    return (
        <div>
            <div className={css.planHeader}>
                <Text tag="h2" size="major-sm">
                    {title}
                </Text>
                <div className={css.pricing}>
                    <Interpolate
                        t={t}
                        i18nKey={t('currencyPrice', { currency: currencySymbol, price: cost })}
                        mapping={{
                            currency: (
                                <Text tag="span" size="body-base" className={css.currencySymbol} />
                            ),
                            price: <Text tag="span" size="minor-lg" className={css.cost} />,
                        }}
                    />
                    <div className={css.details}>
                        <Text tag="span" size="body-2xs">
                            {t('perUser')}
                        </Text>
                        <Text tag="span" size="body-2xs">
                            {t('perMonth')}
                        </Text>
                    </div>
                </div>
            </div>
            <div>{children}</div>
        </div>
    )
}

export function FeatureList({
    children,
    className,
}: {
    children: React.ReactNode
    className?: string
}) {
    return (
        <ul className={cn(css.featureList, className)}>
            {Children.map(children, (child, index) => {
                return (
                    <Text tag="li" size="body-xs" className={css.featureItem} key={index}>
                        {child}
                    </Text>
                )
            })}
        </ul>
    )
}
